// Migrated
<template>
  <footer class="footer w-full mx-auto footer-rolfs px-4 md:px-8">
    <div class="flex flex-wrap">
      <div class="xl:w-3/12 lg:w-3/12 w-12/12 pr-3">
        <div class="footer-logo mb-2 h-auto max-w-72">
          <img
            id="sitelogo"
            :src="logoImg"
            alt="Rolfs Flyg &amp; Buss"
            loading="lazy"
          />
        </div>
        <p class="text-base font-normal md:mr-12">
          {{ $t('footerDescription') }}
        </p>
        <div class="hidden md:block">
          <CrownText
            size="sm"
            color="black"
            class="w-[148px] h-[109px] mb-3"
            :shadow="false"
          />
          <p class="text-base font-normal md:mr-12">
            {{ $t('footerDescription.subtext') }}
          </p>
        </div>
      </div>
      <div class="xl:w-7/12 lg:w-6/12 md:w-12/12">
        <div class="flex flex-wrap">
          <div
            v-for="(column, columnIndex) in footer"
            :key="columnIndex"
            class="footer-menu w-12/12 lg:w-6/12"
          >
            <div class="footer-heading mb-3">
              {{ column.label }}
            </div>
            <ul>
              <li
                v-for="(columnItem, columnItemIndex) in column.links"
                :key="columnItemIndex"
                class="font-inter text-base"
              >
                <a
                  v-if="columnItem.absoluteLink"
                  :href="columnItem.link"
                  target="_blank"
                >
                  {{ columnItem.label }}
                </a>
                <nuxt-link
                  v-else
                  :to="columnItem.link"
                >
                  {{ columnItem.label }}
                </nuxt-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="xl:w-2/12 lg:w-3/12 md:w-12/12">
        <div class="footer-heading mb-3">
          {{ $t('contactUs') }}
        </div>
        <div
          v-if="localeStore.locale !== 'da'"
          class="pb-2 font-inter"
          data-i18n="companyAddress"
        >
          <fa
            class="mr-2"
            icon="map-marker-alt"
            width="11"
          />{{ formattedAddress }}
        </div>
        <a
          class="font-inter !text-black"
          :href="`tel:${$t('companyPhone').replace(/[- ]/g, '')}`"
          data-i18n="companyPhone"
        >
          <fa
            class="mr-2"
            icon="phone"
            width="11"
          />{{ $t('companyPhone') }}</a>
        <div class="pt-2 font-inter">
          <a
            v-if="companyEmail"
            class="py-2 !text-black"
            :href="`mailto:${companyEmail}`"
            data-i18n="companyEmail"
          >
            <fa
              class="mr-2"
              icon="envelope"
              width="11"
            />{{ companyEmail }}</a>
        </div>
        <div class="footer-heading mt-4 mb-2 pb-3">
          {{ $t('followUs') }}
          <div class="mt-3 flex justify-left items-center gap-3">
            <a
              href="https://www.facebook.com/rolfsbuss"
              target="_blank"
              rel="noopener noreferrer"
              class="rounded-full text-blue-800"
              aria-label="Facebook"
            >
              <FacebookSVG class="!w-[35px] !h-[35px]" />
            </a>

            <a
              href="https://www.instagram.com/rolfsbuss/#"
              target="_blank"
              rel="noopener noreferrer"
              class="rounded-full text-blue-800"
              aria-label="Instagram"
            >
              <InstagramSVG class="!w-[35px] !h-[35px]" />
            </a>

            <a
              href="https://www.youtube.com/results?search_query=rolfsbuss"
              target="_blank"
              rel="noopener noreferrer"
              class="rounded-full text-blue-800"
              aria-label="Youtube"
            >
              <YoutubeSVG class="!w-[35px] !h-[35px]" />
            </a>
          </div>
        </div>
        <div class="block md:hidden mt-4">
          <CrownText
            size="sm"
            color="black"
            class="w-[148px] h-[109px] mb-3"
            :shadow="false"
          />
          <p class="font-secondary text-base font-normal md:mr-12">
            {{ $t('footerDescription.subtext') }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap sm:px-0 mt-1">
      <div class="w-12/12 mb-4">
        <hr class="bg-primary border-none h-[2px] my-0" />
      </div>
    </div>
    <div class="flex flex-wrap mb-4 justify-start lg:justify-between mx-0">
      <div
        v-if="$route.name !== 'newsletter'"
        class="lg:w-6/12 w-12/12 pb-2 footer-subscribe"
      >
        <div
          class="text-transform-none mb-2 text-xl font-secondary font-bold"
          data-i18n="newsletterSubscribe"
        >
          {{ $t('newsletterSubscribe') }}
        </div>
        <HydrateWhenVisible class="min-h-[90px] md:min-h-[60px]">
          <LazyNewsletterForm horizontal />
        </HydrateWhenVisible>
      </div>
    </div>
  </footer>
</template>

<script setup>
import FacebookSVG from '@/public/social-media-logo/facebook-logo.svg'
import InstagramSVG from '@/public/social-media-logo/instagram-logo.svg'
import YoutubeSVG from '@/public/social-media-logo/youtube-logo.svg'

const { t } = useI18n()
const rootStore = useRootStore()
const localeStore = useLocaleStore()

const { footerLinks: footer } = storeToRefs(rootStore)
const companyEmail = computed(() => localeStore.getLocaleMessages.companyEmail)

const formattedAddress = computed(() => {
  return t('companyAddress').replace(/(\d{3}) (\d{2})/, '$1\u00a0$2')
})

const logoImg = computed(() => {
  const publicId = t('logo2')
  return formatCloudinaryImagePath(publicId)
})
</script>
